module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am88-2298bd9235a5ca43066cd406b1966513.jpg";